



























import Vue from 'vue';
import axios from 'axios';
import ConfirmDelete from '../components/ConfirmDelete.vue';

export default Vue.extend({
    name: 'Groups',
    components: {
        ConfirmDelete: ConfirmDelete,
    },
    data() {
        return {
            forms: [],
            domainInput: '',
            domainToDelete: '',
            showConfirmDelete: false,
        }
    },
    created() {
        axios.get(this.$store.state.apiUrl + '/domains')
            .then(resp => {
                this.forms = resp.data;
                this.$store.state.routeLoaded = true;
            })
            .catch(e => {
                console.log(e);
                this.$store.state.routeLoaded = true;
            })
    },
    methods: {
        addDomain() {
            if(this.domainInput) {
                axios.post(this.$store.state.apiUrl + '/domains', { domain: this.domainInput })
                .then(resp => {
                    this.forms = resp.data;
                });
            }
            console.log(this.domainInput);
        },
        confirmDelete(domain: string) {
            this.domainToDelete = domain;
            this.showConfirmDelete = true;
        },
        confirmDeleteCB() {
            axios.delete(this.$store.state.apiUrl + '/domains/' + this.domainToDelete)
                .then(resp => {
                    this.forms = resp.data;
                    this.showConfirmDelete = false;
                })
                .catch(e => {
                    this.showConfirmDelete = false;
                })
        },
        cancelDeleteCB() {
            this.showConfirmDelete = false;
        }
    }
})
